import { useCampaignModuleContext } from 'modules/campaigns/context';

type AdCampaignTranslationKeys = {
  agreementStatement: string;
  budgetOptionsDescription: string;
  budgetTitle: string;
  infoBannerText: string;
  scheduleStrategyDescription: string;
  bidAuctionInfo: string;
  scheduleAlwaysOn: string;
};

const summerContestAgreementCountries = [
  'AUT',
  'AZE',
  'CZE',
  'DEU',
  'DNK',
  'EST',
  'FIN',
  'GRC',
  'HUN',
  'ISL',
  'JPN',
  'KAZ',
  'LTU',
  'NOR',
  'SVK',
  'SVN',
  'SWE',
];

const defaultTranslationKeys: AdCampaignTranslationKeys = {
  agreementStatement: 'campaigns.agreements.terms-and-conditions-statement',
  budgetTitle: 'campaigns.ads.budget.weekly-budget',
  budgetOptionsDescription: 'campaigns.ads.budget.budget-options-description',
  infoBannerText: 'campaigns.ads.info-banner.text',
  scheduleStrategyDescription: 'campaigns.ads.schedule.schedule-strategy-description',
  bidAuctionInfo: 'campaigns.ads.bid.bid-auction-info',
  scheduleAlwaysOn: 'campaigns.ads.schedule.always-on',
};

const summerContestAgreementOverrides: Partial<AdCampaignTranslationKeys> = {
  agreementStatement: 'campaigns.agreements.terms-and-conditions-statement-summer-contest',
};

const isrCountryTranslationOverrides: Partial<AdCampaignTranslationKeys> = {
  agreementStatement: 'campaigns.agreements.terms-and-conditions-statement-isr',
  budgetOptionsDescription: 'campaigns.ads.budget.budget-options-description-isr',
  infoBannerText: 'campaigns.ads.info-banner.text-isr',
  scheduleStrategyDescription: 'campaigns.ads.schedule.schedule-strategy-description-isr',
  bidAuctionInfo: 'campaigns.ads.bid.bid-auction-info-isr',
  scheduleAlwaysOn: 'campaigns.ads.schedule.always-on-isr',
};

const multiVenueTranslationKeys: Partial<AdCampaignTranslationKeys> = {
  budgetTitle: 'campaigns.ads.budget.total-weekly-budget',
  budgetOptionsDescription: 'campaigns.ads.budget.budget-options-description-multi-venue',
};

const isrMultiVenueOverrides: Partial<AdCampaignTranslationKeys> = {
  budgetOptionsDescription: 'campaigns.ads.budget.budget-options-description-isr-multi-venue',
};

export function useAdCampaignTranslationKeys(): AdCampaignTranslationKeys {
  const { country, entityType } = useCampaignModuleContext();
  const isMultiVenue = entityType !== 'venue';
  let translationKeys = { ...defaultTranslationKeys };

  if (isMultiVenue) {
    translationKeys = { ...translationKeys, ...multiVenueTranslationKeys };
  }

  if (summerContestAgreementCountries.includes(country)) {
    translationKeys = { ...translationKeys, ...summerContestAgreementOverrides };
  }

  if (country === 'ISR') {
    const multiVenueOverrides = isMultiVenue ? isrMultiVenueOverrides : {};

    translationKeys = {
      ...translationKeys,
      ...isrCountryTranslationOverrides,
      ...multiVenueOverrides,
    };
  }

  return translationKeys;
}
